import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Element } from 'react-scroll'
import registerServiceWorker from './registerServiceWorker'
import {
  Header, Hero, Press, Areas, Testimonials, About, Contact, Footer
} from './components'
import './index.css'
import './assets/fonts/index.css'

class App extends Component {
  constructor () {
    super()
    this.state = { contentPadding: null }
    this.setContentPadding = this.setContentPadding.bind(this)
  }

  setContentPadding (contentPadding) {
    this.setState({ contentPadding })
  }

  render () {
    const { contentPadding } = this.state

    window.location.href = "https://www.hamiltonclarkellp.com/"
    return null

    return (
      <div style={{ paddingTop: `${contentPadding}px` }}>
        <Header setContentPadding={this.setContentPadding} />
        <Hero />
        <Element name="press">
          <Press />
        </Element>
        <Element name="areas">
          <Areas />
        </Element>
        <Testimonials />
        <Element name="about">
          <About />
        </Element>
        <Element name="contact">
          <Contact />
        </Element>
        <Footer />
      </div>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js